import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

// Logo lockup: coral mark + wordmark that adapts to light/dark.
export default function Logo({ className, onClick, showWord = true }) {
  return (
    <Link to="/" onClick={onClick} className={cn('group inline-flex items-center gap-2.5', className)} aria-label="BillPortal home">
      <img src="/BP-Mark.png" alt="BillPortal" className="h-9 w-9 object-contain transition-transform group-hover:scale-105" />
      {showWord && (
        <span className="font-display text-[1.15rem] font-bold tracking-tight text-slate-900 dark:text-white">
          BillPortal
        </span>
      )}
    </Link>
  );
}
